import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import StockReport from "./StockReport";

//pages & includes
import ManageSidebar from "../ManageSidebar";
import DataTable from "../../../../common/DataTable";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  pagination,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import Moment from "react-moment";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { UserContext } from "../../../../../contexts/User";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import ViewAccountSheet from "../../accounts/transactions/ViewAccountSheet";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const StockTransfer = () => {
  const { t } = useTranslation();
  //getting context values here
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  const {
    branchListWeb,
    branchForListSearch,
  } = useContext(RestaurantContext)

  let {
    //stock transfer
    stockTransferList,
    setPaginatedStockTransfer,
    setPaginatedStockTransferList,
    stockTransferForSearch,
    setStockTransferForSearch,
    // units
    units,
    //pagination
    dataPaginating,
  } = useContext(UserContext);

  //search result
  let [searchedStockTransfer, setSearchedStockTransfer] = useState({
    list: null,
    searched: false,
  });

  const [ledgerData, setLedgerData] = useState({
    modal: false,
    ledger: null
  })

  const searchInputRef = useRef(null);

  const toastObj = {
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  }

  //search customers here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0 || stockTransferForSearch === null) {
      setSearchedStockTransfer({ ...searchedStockTransfer, searched: false });
    } else {
      let searchedList = stockTransferForSearch.filter((item) => {
        let lowerCaseTransferNo = item.transfer_no.toLowerCase();
        let lowerCaseTransferDate = item.transfer_date.toLowerCase();
        let lowerCaseBranch = (branchForListSearch[item.from_branch_id])?.name?.toLowerCase();

        return (
          lowerCaseTransferNo.includes(searchInput) ||
          lowerCaseTransferDate.includes(searchInput) ||
          lowerCaseBranch.includes(searchInput)
        );
      });
      setSearchedStockTransfer({
        ...searchedStockTransfer,
        list: searchedList,
        searched: true,
      });
    }
  };

  //print bills states and function
  const [newRow,setNewRow]=useState([]);
  const [purchaseDate,setPurchaseDate]=useState(new Date());
  let [newStockTransfer, setNewStockTransfer] = useState({
    invoice: '',
    branch: '',
    remarks: '',
  });
  const componentRef = useRef();
  
  const handleOnlyPrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: "@page { size: landscape; margin: 30px}"
  });

  useEffect(() => {
    handleFetchData(1)
  }, []);

  const handleGetPrintData = async(id) => {
    const url = BASE_URL + "/settings/stockTransfer/" + parseInt(id);
    
    try {
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
          if(res.data && res.data.stock && res.data.stockDetails){
            let purchaseDate = new Date(res.data.stock.transfer_date);
            setPurchaseDate(purchaseDate);
            let branch= branchListWeb?.find((item)=>item.id === res.data.stock.from_branch_id)            
            setNewStockTransfer({
              ...newStockTransfer,
              invoice: res.data.stock.transfer_no,
              branch,
              remarks: res.data.stock.remarks,              
            })
            let newArr=[];
            if(res.data.stockDetails && res.data.stockDetails.length>0){
              res.data.stockDetails.map((item)=>{
                newArr.push({
                  ingredient_name: item.item_name,
                  qty: parseFloat(item.qty).toFixed(3),
                  rate: parseFloat(item.price).toFixed(2),
                  amount: parseFloat(item.amount).toFixed(2),
                  unit_name: item.unit?.name,
                  to_branch: item.branch?.name,
                })
              })
            }
            setNewRow(newArr)
            handleOnlyPrint();
          }
          
        } catch(error) {
          console.log("error==>",error)
          toast.success(`${_t(t("Please try again"))}`, toastObj);
        }
  }

  const handleGetAmount = (index) => {
    let qty = 0;
    let rate = 0;
    if (newRow !== null && newRow[index].qty !== "") {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    return rate * qty;
  };

  //ledger view
  const handleStockLedger = async(id) =>{
    const url = BASE_URL + "/settings/check-financial-ledger-view/" + parseInt(id) + "/STR";
    try{
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res.data){
        setLedgerData({ modal: true, ledger: res.data});
      }
    }catch(err){
      console.log("error==>",err)
    }
  }

  const handleFetchData = (page) => {
    setPaginatedStockTransfer(page);
  };

  const handleMarkAsPost = async(id) => {

    const url = BASE_URL + "/settings/mark-is-post-stock-transfer";

    let formData = new FormData();
    formData.append('id', id);
    formData.append('is_post', 1);
    setLoading(true);
    try {
      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res.data){
        toast.success(`${t("Stock transfer has been post")}`, toastObj);
        // handleFetchData(1);
        setPaginatedStockTransferList(res);
      }
    }catch(err){
      console.log("error==>",err)
      toast.error(`${t("Please try again")}`, toastObj);
    }finally{
      setLoading(false);
    }
  }

  const COLUMNS = [
    { label: "S/L", render: (item, i) => i + 1 },
    { label: "Transfer Number", key: "transfer_no" },
    {
      label: "Transfer Date",
      render: (item) => <Moment format="DD-MMMM-YYYY">{item.transfer_date}</Moment>,
    },
    { 
      label: "From Branch", 
      render: (item) => branchForListSearch[item.from_branch_id] && branchForListSearch[item.from_branch_id].name
        ? branchForListSearch[item.from_branch_id].name
        : ''
    },
    { label: "To Branch", key: "branches" },
    { label: "Remarks", key: "remarks" },
    {
      label: "Created Date",
      render: (item) => <Moment format="DD-MMMM-YYYY hh:mm A">{item?.created_at}</Moment>,
    },
    {
      label: "Action",
      render: (item) => (
        <div className="d-flex justify-content-center">
          <NavLink
            className="btn btn-primary ml-2 rounded-sm"
            to={`/dashboard/manage/stock/stock-transfer-view/${item.id}`}
            style={{height:"1.7rem",width:"1.7rem"}}
          >
            <div className="d-flex align-items-center justify-content-center">
              <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
            </div>
          </NavLink>
          <button
            className="btn btn-secondary ml-2 rounded-sm del-btn"
            onClick={()=>handleGetPrintData(item.id)}
          >
            <i className="fa fa-print edit-icon"></i>
          </button>
          <button
            title="ledger view"
            className="btn btn-success ml-2 rounded-sm del-btn"
            onClick={()=>handleStockLedger(item.id)}
          >
            <i className="fa fa-eye" aria-hidden="true"></i>
          </button>
          {item.is_post != 1 && (
            <button
              title="Post stock transfer"
              className="btn btn-dark ml-2 rounded-sm del-btn"
              onClick={()=>handleMarkAsPost(item.id)}
            >
              <i className="fa fa-check-square-o" aria-hidden="true"></i>
            </button>
          )}
        </div>
      ),
    },
  ];

  const getListData = useCallback(() => {
    if (searchedStockTransfer.searched) {
      return searchedStockTransfer.list;
    }

    return stockTransferList?.data || [];
  }, [searchedStockTransfer, stockTransferList]);

  const onClearSearch = () => {
    setSearchedStockTransfer({ ...searchedStockTransfer, searched: false });
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Stock Transfer"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                      <div key="fragment3">
                        {/* next page data spin loading */}
                        {/* <CustomSpinLoader loading={loading || dataPaginating}/> */}
                        {/* spin loading ends */}

                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {t("Stock Transfer List")}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center">
                              {/* Search customer */}
                              <div className="col-md-9 t-mb-15 mb-md-0">
                                <div className="input-group">
                                  <div className="form-file">
                                    <input
                                      type="text"
                                      className="form-control border-0 form-control--light-1 rounded-left"
                                      placeholder={_t(t("Search")) + ".."}
                                      onChange={handleSearch}
                                      ref={searchInputRef}
                                      disabled={loading || dataPaginating}
                                    />
                                  </div>
                                  <button
                                    className="btn btn-primary rounded-right"
                                    type="button"
                                  >
                                    <i
                                      className="fa fa-search"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              {/* Add customer modal trigger button */}
                              <div className="col-md-3 text-md-right">
                                <NavLink
                                  to="/dashboard/manage/stock/stock-transfer-add"
                                  className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                                >
                                  {(t("add new"))}
                                </NavLink>
                              </div>
                            </div>
                          </div>
                        </div>

                        <DataTable
                          loading={loading || dataPaginating}
                          data={getListData()}
                          columns={COLUMNS}
                          emptyText="No data available"
                          pagination={{
                            isPageLoading: dataPaginating,
                            isPagination: true,
                            pageCount: stockTransferList?.last_page,
                            currentPage: stockTransferList?.current_page,
                            from: stockTransferList?.from,
                            to: stockTransferList?.to,
                            total: stockTransferList?.total,
                          }}
                          handleFetchData={handleFetchData}
                          searchPayload={{
                            isSearched: searchedStockTransfer.searched,
                            onClearSearch,
                          }}
                        />
                      </div>                    
                  </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
      <StockReport
        name = "Stock Transfer"
        purchaseDate={purchaseDate}
        newItem={newStockTransfer}
        newRow={newRow}
        invoiceNo = {"Transfer No"}
        inoviceDate = {"Transfer Date"}
        handleGetTotal={""}
        handleAmount={""}
        handleTaxAmount={""}
        handleDisAmount={""}
        handleGetSubTotal={""}
        handleGetAmount={""}
        stockPrint={componentRef}
      /> 
      <ViewAccountSheet
        accountLedger={ledgerData}
        setAccountLedger= {setLedgerData}
      />
    </>
  );
};

export default StockTransfer;
